import React from "react";
import { useSelector } from 'react-redux';
import { floral } from '../language';

const SERVICE_ITEMS = [
  {
    key: 'bouquets',
    image: '/img/site_imgs/bridal_bouquets.jpg',
    alt: 'A bride in a lace wedding gown holding a bouquet of white roses and ranunculus.',
  },
  {
    key: 'ceremony',
    image: '/img/site_imgs/ceremony_floral.jpg',
    alt: 'A bride and groom exchanging vows in front of a floral-adorned fireplace mantel.',
  },
  {
    key: 'reception',
    image: '/img/site_imgs/reception_florals.jpg',
    alt: 'A long reception table lined with white and blush floral centerpieces and taper candles.',
  },
  {
    key: 'installations',
    image: '/img/site_imgs/floral_installation.jpg',
    alt: 'A large floral mantel installation with colorful garden roses and delphinium.',
  },
];

function Services(props) {
  const languageEN = useSelector((state) => {
    return state.app.languageEN;
  });
  const language = languageEN ? 'en' : 'ch';

  return (
    <div id="services" className="lf-bg-white lf-section-anchor">
      <div className="lf-editorial lf-section py-5">
        <div id="weddings" className="lf-reveal" style={{ maxWidth: '40rem', scrollMarginTop: '5rem' }}>
          <p className="lf-eyebrow">{floral.services.eyebrow[language]}</p>
          <h2 className="lf-section-heading" style={{ fontSize: '2.35rem', lineHeight: 1.22, letterSpacing: '-0.04em' }}>
            {floral.services.title[language]}
          </h2>
          <p className="mt-3" style={{ color: 'var(--lf-muted)', lineHeight: 1.55 }}>
            {floral.services.description[language]}
          </p>
        </div>
        <div className="row mt-4">
          {SERVICE_ITEMS.map((item) => {
            return (
              <div className="col-md-6 mb-4 lf-reveal" key={item.key}>
                <div className="lf-image-frame" style={{ aspectRatio: '16 / 10' }}>
                  <img src={item.image} alt={item.alt} loading="lazy" decoding="async" />
                </div>
                <div className="lf-service-card d-flex justify-content-between align-items-start mt-3">
                  <div>
                    <h3 className="lf-display" style={{ fontSize: '1.42rem' }}>{floral.services[item.key].title[language]}</h3>
                    <p className="mt-2" style={{ fontSize: '0.9rem', color: 'var(--lf-muted)', maxWidth: '22rem' }}>
                      {floral.services[item.key].text[language]}
                    </p>
                  </div>
                  <span style={{ color: 'var(--lf-sage-dark)', marginTop: '0.2rem' }}>
                    <i className="fa-solid fa-arrow-up-right-from-square"></i>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export { Services };
